// extracted by mini-css-extract-plugin
module.exports = {"purchaseResourceSearchMap":"PurchaseResourceSearchMap_purchaseResourceSearchMap__jTi1M"};